import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { drawingToolIcons } from "@vninvestcharts/engine-react";
function Svg({ size = 15, children, ...props }) {
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", ...props, children: children }));
}
/**
 * Drawing-tool glyph from the central registry (@vninvestcharts/engine-react (drawingToolIcons)).
 * P4: unknown ids render a dashed placeholder (plus a dev-only warning) instead
 * of nothing — a missing glyph must stay visible, never silent.
 */
export function ToolGlyph({ id }) {
    const glyph = drawingToolIcons[id];
    if (glyph)
        return _jsx(_Fragment, { children: glyph });
    if (typeof process !== "undefined" && process.env?.NODE_ENV !== "production") {
        console.warn(`[ToolGlyph] missing icon for tool "${id}"`);
    }
    return (_jsx("svg", { width: "15", height: "15", viewBox: "0 0 16 16", fill: "none", "aria-hidden": "true", children: _jsx("rect", { x: "2.5", y: "2.5", width: "11", height: "11", rx: "2", stroke: "currentColor", strokeWidth: "1.2", strokeDasharray: "2 2" }) }));
}
export function IconSearch(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("circle", { cx: "7.5", cy: "7.5", r: "4.5" }), _jsx("line", { x1: "11", y1: "11", x2: "14", y2: "14" })] }));
}
export function IconX(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("line", { x1: "3", y1: "3", x2: "13", y2: "13" }), _jsx("line", { x1: "13", y1: "3", x2: "3", y2: "13" })] }));
}
export function IconMenu(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("line", { x1: "2", y1: "4", x2: "14", y2: "4" }), _jsx("line", { x1: "2", y1: "8", x2: "14", y2: "8" }), _jsx("line", { x1: "2", y1: "12", x2: "14", y2: "12" })] }));
}
export function IconLock(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("rect", { x: "3.5", y: "7", width: "9", height: "7", rx: "1.5" }), _jsx("path", { d: "M5.5 7V5a2.5 2.5 0 0 1 5 0v2" })] }));
}
export function IconUnlock(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("rect", { x: "3.5", y: "7", width: "9", height: "7", rx: "1.5" }), _jsx("path", { d: "M5.5 7V5a2.5 2.5 0 0 1 4.9-.8" })] }));
}
export function IconChevronUp(props) {
    return (_jsx(Svg, { ...props, children: _jsx("polyline", { points: "4,10 8,6 12,10" }) }));
}
export function IconChevronDown(props) {
    return (_jsx(Svg, { ...props, children: _jsx("polyline", { points: "4,6 8,10 12,6" }) }));
}
export function IconChevronLeft(props) {
    return (_jsx(Svg, { ...props, children: _jsx("polyline", { points: "10,4 6,8 10,12" }) }));
}
export function IconChevronRight(props) {
    return (_jsx(Svg, { ...props, children: _jsx("polyline", { points: "6,4 10,8 6,12" }) }));
}
export function IconTrash(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M2.5 4h11" }), _jsx("path", { d: "M6.5 4V2.5h3V4" }), _jsx("path", { d: "M4 4l.8 9.2a1 1 0 0 0 1 .8h4.4a1 1 0 0 0 1-.8L12 4" }), _jsx("line", { x1: "6.5", y1: "7", x2: "6.5", y2: "11" }), _jsx("line", { x1: "9.5", y1: "7", x2: "9.5", y2: "11" })] }));
}
export function IconUndo(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polyline", { points: "5.5,3.5 2.5,6.5 5.5,9.5" }), _jsx("path", { d: "M2.5 6.5h7a3.5 3.5 0 0 1 0 7H7" })] }));
}
export function IconRedo(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polyline", { points: "10.5,3.5 13.5,6.5 10.5,9.5" }), _jsx("path", { d: "M13.5 6.5h-7a3.5 3.5 0 0 0 0 7H9" })] }));
}
export function IconSun(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "2.5" }), _jsx("path", { d: "M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41" })] }));
}
export function IconMoon(props) {
    return (_jsx(Svg, { ...props, children: _jsx("path", { d: "M13.5 11A5.5 5.5 0 1 1 5 2.5a4.5 4.5 0 0 0 8.5 8.5z" }) }));
}
export function IconClock(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6" }), _jsx("polyline", { points: "8,4.5 8,8 10.5,9.5" })] }));
}
export function IconSync(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polyline", { points: "13,2.5 13,6 9.5,6" }), _jsx("path", { d: "M11.2 8.5a4.5 4.5 0 1 1-1.3-4.2L13 6" }), _jsx("polyline", { points: "3,13.5 3,10 6.5,10" }), _jsx("path", { d: "M4.8 7.5a4.5 4.5 0 1 1 1.3 4.2L3 10" })] }));
}
export function IconLayoutGrid(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("rect", { x: "2.5", y: "2.5", width: "4.5", height: "4.5", rx: "1" }), _jsx("rect", { x: "9", y: "2.5", width: "4.5", height: "4.5", rx: "1" }), _jsx("rect", { x: "2.5", y: "9", width: "4.5", height: "4.5", rx: "1" }), _jsx("rect", { x: "9", y: "9", width: "4.5", height: "4.5", rx: "1" })] }));
}
export function IconPlus(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("line", { x1: "8", y1: "3", x2: "8", y2: "13" }), _jsx("line", { x1: "3", y1: "8", x2: "13", y2: "8" })] }));
}
export function IconSave(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M12 2 H4 A2 2 0 0 0 2 4 V12 A2 2 0 0 0 4 14 H12 A2 2 0 0 0 14 12 V4 A2 2 0 0 0 12 2 Z" }), _jsx("rect", { x: "5", y: "2", width: "6", height: "4" }), _jsx("rect", { x: "4", y: "9", width: "8", height: "5" })] }));
}
export function IconFolderOpen(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M2 10 V14 H14 V10" }), _jsx("path", { d: "M8 2 V10 M5 7 L8 10 L11 7" })] }));
}
export function IconCamera(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M5 5.5 L6 3.5 H10 L11 5.5" }), _jsx("rect", { x: "2", y: "5.5", width: "12", height: "8", rx: "1.5" }), _jsx("circle", { cx: "8", cy: "9.5", r: "2" })] }));
}
export function IconExpand(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M3 6V3.5A.5.5 0 0 1 3.5 3H6" }), _jsx("path", { d: "M10 3h2.5a.5.5 0 0 1 .5.5V6" }), _jsx("path", { d: "M13 10v2.5a.5.5 0 0 1-.5.5H10" }), _jsx("path", { d: "M6 13H3.5a.5.5 0 0 1-.5-.5V10" })] }));
}
export function IconBell(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M8 2 C9.5 2 11 3.5 11 5 L11 9 C11 10.5 12 11 12 11.5 L4 11.5 C4 11 5 10.5 5 9 L5 5 C5 3.5 6.5 2 8 2 Z" }), _jsx("path", { d: "M7 13 A1 1 0 0 0 9 13" })] }));
}
export function IconSettings(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polygon", { points: "8,2 13.5,5 13.5,11 8,14 2.5,11 2.5,5" }), _jsx("circle", { cx: "8", cy: "8", r: "2.5" })] }));
}
export function IconCompare(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("line", { x1: "12", y1: "2", x2: "12", y2: "14" }), _jsx("line", { x1: "4", y1: "8", x2: "10", y2: "8" }), _jsx("line", { x1: "6", y1: "12", x2: "14", y2: "12" })] }));
}
export function IconReplay(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.5" }), _jsx("polygon", { points: "6.5,5.5 11.5,8 6.5,10.5", fill: "currentColor", stroke: "none" })] }));
}
export function IconDownload(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polyline", { points: "4.7,6.7 8,10 11.3,6.7" }), _jsx("line", { x1: "8", y1: "10", x2: "8", y2: "2" }), _jsx("path", { d: "M14 10v2.7a1.3 1.3 0 0 1-1.3 1.3H3.3A1.3 1.3 0 0 1 2 12.7V10" })] }));
}
export function IconList(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("circle", { cx: "3", cy: "4.5", r: "1", fill: "currentColor", stroke: "none" }), _jsx("circle", { cx: "3", cy: "8", r: "1", fill: "currentColor", stroke: "none" }), _jsx("circle", { cx: "3", cy: "11.5", r: "1", fill: "currentColor", stroke: "none" }), _jsx("line", { x1: "6", y1: "4.5", x2: "14", y2: "4.5" }), _jsx("line", { x1: "6", y1: "8", x2: "14", y2: "8" }), _jsx("line", { x1: "6", y1: "11.5", x2: "14", y2: "11.5" })] }));
}
export function IconBarChart(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("line", { x1: "2", y1: "13.5", x2: "14", y2: "13.5" }), _jsx("line", { x1: "4.5", y1: "9", x2: "4.5", y2: "13.5" }), _jsx("line", { x1: "8", y1: "6", x2: "8", y2: "13.5" }), _jsx("line", { x1: "11.5", y1: "3.5", x2: "11.5", y2: "13.5" })] }));
}
export function IconLayers(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polygon", { points: "8,2 14,5.5 8,9 2,5.5" }), _jsx("polyline", { points: "2,8.5 8,12 14,8.5" }), _jsx("polyline", { points: "2,11.5 8,15 14,11.5" })] }));
}
export function IconActivity(props) {
    return (_jsx(Svg, { ...props, children: _jsx("polyline", { points: "14,8 10,8 8,3.5 6,12.5 4,8 2,8" }) }));
}
export function IconLink(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M10 6.5a3.5 3.5 0 0 0-5 0l-2 2a3.5 3.5 0 0 0 5 5l1.5-1.5" }), _jsx("path", { d: "M6 9.5a3.5 3.5 0 0 0 5 0l2-2a3.5 3.5 0 0 0-5-5L6.5 4" })] }));
}
export function IconEye(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M1.5 8S4.5 3.5 8 3.5 14.5 8 14.5 8 11.5 12.5 8 12.5 1.5 8 1.5 8z" }), _jsx("circle", { cx: "8", cy: "8", r: "1.8" })] }));
}
export function IconEyeOff(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M1.5 8S4.5 3.5 8 3.5c1.2 0 2.5.5 3.5 1.3M14.5 8S11.5 12.5 8 12.5c-1.2 0-2.5-.5-3.5-1.3" }), _jsx("line", { x1: "2.5", y1: "13.5", x2: "13.5", y2: "2.5" })] }));
}
export function IconCode(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("polyline", { points: "6,5 3,8 6,11" }), _jsx("polyline", { points: "10,5 13,8 10,11" })] }));
}
export function IconFlask(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M7 2v4.5L3.8 12a1 1 0 0 0 .9 1.5h6.6a1 1 0 0 0 .9-1.5L9 6.5V2" }), _jsx("path", { d: "M6 2h4" }), _jsx("line", { x1: "7", y1: "10.5", x2: "9", y2: "10.5" })] }));
}
export function IconStar(props) {
    return (_jsx("svg", { width: props.size ?? 15, height: props.size ?? 15, viewBox: "0 0 16 16", fill: "currentColor", "aria-hidden": "true", children: _jsx("path", { d: "M8 1.5l1.9 3.9 4.3.6-3.1 3 .7 4.3L8 11.3l-3.8 2 .7-4.3-3.1-3 4.3-.6L8 1.5z" }) }));
}
/**
 * E1 hover-pin: pushpin glyph for the dock pin toggle (panel header).
 * 16x16 / 1.5px stroke / currentColor / round — matches file conventions.
 */
export function IconPin(props) {
    return (_jsxs(Svg, { ...props, children: [_jsx("path", { d: "M9.5 2.5h5v3.5l-2.5 1v3.2l1.7 1.1v.7H6.3v-.7L8 10.2V7l-2.5-1V2.5h4z" }), _jsx("line", { x1: "8", y1: "12", x2: "8", y2: "14.5" })] }));
}
/**
 * P4-dock: vertical "more" grip — mirror of the drawing toolbar handle
 * (3 vertical dots). Used by the free-tier dock rail (DockUpgradeNudge).
 */
export function IconMoreVertical(props) {
    return (_jsxs("svg", { width: props.size ?? 15, height: props.size ?? 15, viewBox: "0 0 16 16", fill: "currentColor", "aria-hidden": "true", children: [_jsx("circle", { cx: "8", cy: "3", r: "1.4" }), _jsx("circle", { cx: "8", cy: "8", r: "1.4" }), _jsx("circle", { cx: "8", cy: "13", r: "1.4" })] }));
}
